module.exports = __webpack_public_path__ + "static/img/4157_phase_function_Paper_PointsHejduk_Prediction.1561bee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4157_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 8b89
// module chunks = 0